import {
  addLeadingZeroesToZip,
  downcaseEmail,
  standardizeFullName,
} from "../hooks"
import { addressFields, contactFields, getBoatFields } from "./shared"

export const getLongTermWaitlistConfig = ({ boatTypes, waitlistGroups }) => {
  // supercede the `boat_name`, `boat_type`, `measurement_unit` and `length_overall`
  // shared fields with fields that include presence validations
  const baseBoatFields = getBoatFields(boatTypes)
  const boatFieldsWithOverrides = {
    ...baseBoatFields,
    boatName: {
      ...baseBoatFields.boatName,
      validators: [{ validate: "required" }],
    },
    boatType: {
      ...baseBoatFields.boatType,
      validators: [{ validate: "required" }],
    },
    measurementUnit: {
      ...baseBoatFields.measurementUnit,
      validators: [{ validate: "required" }],
    },
    lengthOverall: {
      ...baseBoatFields.lengthOverall,
      validators: [{ validate: "required" }],
    },
  }

  const fields = [
    ...Object.values(contactFields),
    ...Object.values(addressFields),
    ...Object.values(boatFieldsWithOverrides),
    {
      label: "Waitlist Group",
      key: "waitlist_group_encoded_id",
      type: "select",
      selectOptions: [{ value: "", label: "" }, ...waitlistGroups],
      description:
        "The waitlist group the entry should be added to. May be left blank.",
    },
    {
      label: "Requested At Date",
      key: "requested_at_date",
      type: ["date", { locale: "en-US" }],
      description:
        "The date the waitlist entry should be noted as having been requested on. Use format MM/DD/YYYY. If given the same date for multiple entries, they will be created in Dockwa in the order they were entered in the import.",
    },
    {
      label: "Special Request",
      key: "special_request",
      type: "string",
      description:
        "Any special request from the customer. NOTE: This will start a message thread for the waitlist entry (with the waitlisted customer), with the text you enter here as a message from the customer to you.",
    },
    {
      label: "Internal Note",
      key: "internal_note",
      type: "string",
      description:
        "A note about the waitlist entry that will not be visible to the customer.",
    },
  ]

  const columnHooks = [
    { fieldName: "name", callback: standardizeFullName },
    { fieldName: "zip", callback: addLeadingZeroesToZip },
  ]

  const rowHooks = [downcaseEmail]

  return { fields, columnHooks, rowHooks }
}
